import { createContext } from 'react';

import { useConnections } from '@frontend/api/hooks';

import { BaseConnectionProvider } from './BaseConnectionProvider';
import { ConnectionContextType } from './connectionUtils';

const ConnectionContext = createContext<ConnectionContextType>({
  products: {},
});

const ConnectionProvider = ({ children }: { children: React.ReactNode }) => {
  const { connectionGetter } = useConnections();

  return (
    <BaseConnectionProvider connectionGetter={connectionGetter} context={ConnectionContext}>
      {children}
    </BaseConnectionProvider>
  );
};

export type { ConnectionContextType };
export { ConnectionContext, ConnectionProvider };
